//#region Mailing

let email = {
    sendTest(p) {
        $.ajax({
            type: "GET",
            url: __root + "Mailing/SendTestEmail?p=" + p,
            processData: false,
            datatype: "json",
            success: function (response) {
                if (response.statusCode == 200) {
                    //toastr.success(response.value) 
                    modal.getModal.success("~{Success}", response.value, true)
                } else {
                    //toastr.error(response.value)
                    modal.getModal.danger(__l.Error, response.value, true)
                }
            },
            beforeSend: function () { loading.show($('.send-test-mail')) },
            complete: function () { loading.hide($('.send-test-mail')) }
        })
    },
    addMarker(marker) {
        let targetPostion = tinymce.activeEditor.selection.getNode()
        let $container = $(tinymce.activeEditor.iframeElement).closest('.kdr-tinymce-editor-container')

        if ($(targetPostion).is(':visible') && !$container.find('textarea').hasClass('tinymce-no-markers')) {
            let $marker = $(marker).clone().detach()
            let insertContent = $marker.prop('outerHTML')

            if ($marker.find('.marker-section').length > 0) {
                insertContent += '<br/><br/>' + insertContent
            }

            tinymce.activeEditor.execCommand('mceInsertRawHTML', false, insertContent)
        }
    },
    saveColumnsOrder(mail, columns, $loadingIndicator, successCallback) {
        $.ajax({
            type: "POST",
            url: __root + "Mailing/SaveMailTable",
            datatype: "json",
            traditional: true,
            data: {
                mail: mail,
                cols: JSON.stringify(columns),
            },
            success: function (response) {
                if (response.code == gridResponseCodes.SUCCESS) {
                    successCallback && successCallback()
                } else {
                    modal.getModalAjax({
                        type: response.code,
                        title: __l.Error,
                        message: response.message,
                        isCloseButton: false
                    })
                }
            },
            beforeSend: function () { loading.show($loadingIndicator) },
            complete: function () { loading.hide($loadingIndicator) }
        })
    },
    restoreDefaultColumn(mail, $loadingIndicator, successCallback) {
        $.ajax({
            type: "POST",
            url: __root + "Mailing/RestoreMailTable",
            datatype: "json",
            traditional: true,
            data: {
                mail: mail,
            },
            success: function () {
                successCallback && successCallback()
            },
            beforeSend: function () { loading.show($loadingIndicator) },
            complete: function () { loading.hide($loadingIndicator) }
        })
    }
}

$(document).on('click', '.send-test-mail', function () { email.sendTest($(this).data('p')) })

$(document).on('click', '#edit-mailing .kdr-grid-edit-ext', function () {
    $('.send-test-mail').hide()
})
$(document).on('click', '#edit-mailing .kdr-grid-cancel-ext', function () {
    $('.send-test-mail').show()
})
$(document).on(gridEvents.AFTER_RENDER, '#grid-edit-mail', function (reponse) {
    if (gridResponseCodes.SUCCESS == reponse.code) {
        $('.send-test-mail').show()
    }
})

$(document).on('click', '.marker-parent', function (event) {
    email.addMarker($(this))
})

$(document).on('click', '#minimize-marker-window', function () {
    $('.markers-wrapper').addClass('window-right-out')
})

$(document).on('animationend', '.window-right-out', function () {
    $('.markers-wrapper').hide()
    $('.markers-wrapper').removeClass('window-right-out')
    $('#show-marker-window').addClass('button-left-in')
    $('#show-marker-window').removeClass('hide')
})

$(document).on('animationend', '.window-left-in', function () {
    $('.markers-wrapper').removeClass('window-left-in')
})

$(document).on('click', '#show-marker-window', function () {
    $('#show-marker-window').addClass('button-right-out')
})

$(document).on('animationend', '.button-right-out', function () {
    $('#show-marker-window').addClass('hide')
    $('#show-marker-window').removeClass('button-right-out')
    $('.markers-wrapper').addClass('window-left-in')
    $('.markers-wrapper').show()
})

$(document).on('animationend', '.button-left-in', function () {
    $('#show-marker-window').removeClass('button-left-in')
})

$(document).on('focusout', '#tinymce.editor-content', function () { email.sendTest($(this).data('p')) })
$(document).on('click', '#edit-mailing .kdr-grid-edit-ext', function () {
    $('.markers-wrapper').show()
    $('#show-marker-window').addClass('hide')
    $('.delete-marker').removeClass('hide')
})

$(document).on('click', '#edit-mailing .kdr-grid-save-ext', function () {
    $('.markers-wrapper').hide()
    $('.markers-wrapper').addClass('window-left-in')
    $('#show-marker-window').addClass('hide')
    $('.delete-marker').addClass('hide')
})

$(document).on('click', '#edit-mailing .kdr-grid-cancel-ext', function () {
    $('.markers-wrapper').hide()
    $('.markers-wrapper').addClass('window-left-in')
    $('#show-marker-window').addClass('hide')
    $('.delete-marker').addClass('hide')
})

$(document).on(gridEvents.BEFORE_RENDER, '#grid-edit-mail', function (event) {
    if (event.code == gridResponseCodes.SUCCESS) {
        $('.markers-wrapper').hide()
    }
})


$(document).on(gridEvents.BEFORE_RENDER, '#add-mailing-grid', function (event) {
    if (event.code == gridResponseCodes.SUCCESS) {
        controls.refresh(null, 'mailing-grid')
        $('#add-mailing-modal').modal('hide')
    }
})

$(document).on('click', '.mail-table-columns-save-order', function () {
    let $modal = $(this).closest('.modal-content')
    let items = []
    let mail = $(this).data('p')

    $modal.find(".mail-table-column-container").each((i, e) => {
        let $col = $(e)
        items.push({
            column: $col.data('p'),
            activeP: $col.find('.kdr-custom-checkbox').valExtended()
        })
    })

    if (items.filter(x => x.activeP == true).length == 0) {
        modal.getModal.danger(__l.Error, '~{At least one column must by active.}', true)
    } else {
        email.saveColumnsOrder(mail, items, $modal, () => {
            modalHelper.removeModalFromBody($modal.closest('.modal'))
            toastr.success(__l.SuccessfullySaved)
        })
    }
})


$(document).on('click', '.mail-table-columns-restore-default', function () {
    let $btn = $(this)
    let $modal = $btn.closest('.modal-content')
    let mail = $btn.data('p')

    email.restoreDefaultColumn(mail, $modal, () => {
        modalHelper.removeModalFromBody($modal.closest('.modal'))
        toastr.success(__l.SuccessfullyRestored)
    })
})

//#endregion Mailing